module.exports = __webpack_public_path__ + "img/consulta.adbc9320.png";